module.exports = __webpack_public_path__ + "img/text-file-icon.269eabd9.svg";